var _defs, _defs2, _rect, _circle, _path, _path2, _path3, _path4, _path5, _path6, _polygon, _polygon2, _polygon3, _polygon4, _path7, _path8, _path9, _path10, _path11, _path12, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _path13, _path14, _path15, _path16, _path17, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _rect15, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _polygon10, _path48, _polygon11, _polygon12, _polygon13, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBusinessDeal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    id: "SvgjsSvg1001",
    width: 845,
    height: 810,
    style: {
      backgroundColor: "white"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "SvgjsDefs1002"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG1008"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 180 264.83",
    width: 845,
    height: 810,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M222.46,17.85s-.53,1-1.34,1-1.68,1.09-2.06.47-.28-1.37-1.21-1.47-2.46-.4-2.34-1,.16-1.52-.62-1.55-.16-.72-1.19-.78a2.24,2.24,0,0,1-2-1.25c-.19-.62-1-1-1.31-1.68s-.62-.25-.81-.47.06-.75-.47-.81-.31.44-1.31.22-.12.4-.68.25-.28-.67-.78-.47-.31.84-1,.28-.47.38-.75.41-.78-.07-1.09.12-.4-.28-.9-.28-.87.44-.28.84.67.81-.31.47a3.77,3.77,0,0,0-2.84.12c-.44.38-.28.69-.84,1s.37.53-.47.84-1.62.31-1.59,1,.28,1.68.25,2,.5.53,1.34.32a1.48,1.48,0,0,1,1.68.59c.44.46.69.56.72,1s.59.72.86.38.36,0,.36.59a1.42,1.42,0,0,0,1.3,1.18c.66.07.6.56-.06,1a5.07,5.07,0,0,0-1.84,1.43c-.37.66-1.09.13-1.21.72s.5.19.28.84-.16.84.22,1.15-.59.38-.5,1,.56,0,.62,1.12.53.87.41,1.37-.78,1.72-.41,2.43a1.94,1.94,0,0,0,2.12,1c1.12-.09.62,1.25,2,1.28s-.21,1.25,1.22,1.53,2.4.53,2.59.93a.79.79,0,0,1-.43,1,.58.58,0,0,1-.26.06c-.62,0-.44-.28-1.15.28s-1.28.13-1.78,1-.56.84,0,1.56,0,1.24-.12,1.77,1.12.72-.1,1-.9.84-1.43,1.59-1.53.93-1.46,1.84.12,1.06-.75,1.46-2.06.87-2.12,1.43a5.71,5.71,0,0,1-.87,2.5c-.5.56-1.37,2.61-2.21,2.68s-1.34.06-1.34.56-.94.18-1.28,1.09.09,1.21-.72,1.65-.9.68-1,1-.1.56-1.13.5-3.16.21-3.65.71-.93-.46-.55-1.52-2-.6-2.68.18-.78,1.75-1.62,2.22-3.43,2-2.53,3.86,1.25,1.71,2.06,1.74,1.25-.09.84.63-1.06,1.15-.56,2a13.36,13.36,0,0,0,1.28,2.46c.4.32,1.15-.43,1.43.25s-.4,1.25.28,1.81.87.84.72,1.59.68.44.56,1.37.19,2-.9,2-.28-1.55-1.19-1.09-1.37.66-2,.44.22.81-.72.84-1.71-1.46-2.37-1.09-1.37.9-2.11.22-.75.06-1.87-.09-.22,1.8-.66,1.77-1.59-1.37-2.09-.59-.06,1.74-.65,2.15-.69.84.28,1.06,1.09,1.09,1.5,1.81a8.23,8.23,0,0,0,3.39,2.4c1,.28,2.15,1.15,2.87.46s.25-.78,1.31-.53,1.46-.93,1.52-.31-1.09,1.65-2.08,1.56-1,.44-2,.47-1.28.59-1.65-.16-1.15-.84-1.5-.31-1,1.49-.12,2.43a45.79,45.79,0,0,1,4.33,5c.9,1.38,1.12,2,2.15,2.09s.22.5,1.47,1.12,1.24.75,2.08.35,1.28-.1,2.65-.72,1.81-.12,2.53-.9,1.12-.75,1.49-1.84,1-.66.62-1.62-.31-2.46,0-2.46,1.25.78.75,1.24-.47,1.44,0,1.69.37.81,0,1.34a1.6,1.6,0,0,0,.28,2c.53.68,1.12,1.31.62,2.21a13.61,13.61,0,0,0-.87,2.49c-.22.6-.78,1.09-.25,1.78a2.21,2.21,0,0,1,.53,2.15,9.75,9.75,0,0,0,.72,5.36c1,1.93,1.09,2.37,1.15,3.46a37.69,37.69,0,0,0,1.37,7.82c.75,1.84,4.36,7.51,4.58,9a50.38,50.38,0,0,0,2.49,8.85c.91,1.84,1.16,2.84,1.94,3.27s2.33,3.59,2.43,4,.15,1.75.71,2.15.1,1.68,1,2.31.19.5.53,2a8.76,8.76,0,0,1,.5,2.43c-.06.56.5.69.5,1.37a1.94,1.94,0,0,0,.56,1.65c.62.87,1.59,2.5,2.21,2.53s.81-.13,1,.62.75.53,1.28.72.93,1.4,1.87.62,1.62-1.75,2.39-1.71,1.25-.41,1.13-1.87a1.73,1.73,0,0,1,1.36-2,1.63,1.63,0,0,1,.44,0c1-.09,2.93,0,3.12-.75s-1.9-1-.56-2.37,1.93-1.55,1.62-2.11-.22-.69,1.12-.63,2.18.25,2.15-1.09.31-3.46-.31-4.42.12-.84,0-1.69-.41-.68.22-1.8,1.24-1.06,1.3-2-.74-1.06,0-1.4a2.88,2.88,0,0,0,1.5-2.9,14.76,14.76,0,0,0-.81-3.46c-.41-.71-1.15-1.21-.44-2s.6-1,.13-2.12-.94-2.9,0-3.49.56-2.12,2-2.15,3.52-1.87,3.84-2.52.18.06,1.62,0a4.08,4.08,0,0,0,3.17-1.16c.68-.81,1.16-1.09.6-2s-.22-1.06.78-1.46,1-.72,2.11-1.22,1.94-.84,2.25-2.34,2.55-1.77,3.52-3,2.21-1.93,2.49-2.87-.44-.9,1.06-1.86,1.68-1.16,2.71-1.87,5.67-1.84,6.11-4.8c0,0-.22-.28.4-.56s.69-1.65.28-2.28-1.26-1.37.26-2,3.45-.35,4.07-1.72.85.53,2.56-.59,1.43,1.12,2.43-1-1.74-2.12-1.28-4.8-1-1.87-1.09-3.14-1-1.22-.59-2.28.72-1.12.47-2.3-2.37-.07-2.68-1.37-.31-1.31.25-1.31-.6-1.5,1.59-1.81,2-1.06,1.55-1.68-.53-.94-1.09-1.09-.28.78-1,.06A8.09,8.09,0,0,0,269,70.23c-.53-.31.15-1.78.75-1.78s.49-.68.62.53,1.56.72,1.59,0,.47-.56,1.15.19,1.25,1.09,1.84.62.9-.53.69.63.48.37.06,1.55-.06,1.53,2.83,2,2.18-.44,4.27-.25,3-.56,3.87-.16.77,1.44.21,2.28-.56,1.43-1.55,1.77-2.19.88-2.4,2.06-.38,2.31.09,2.68.59,1.84.59,2.15,1.19.06,1.9.93,1.37-1.15,1.34-2.27.52-.93.46-1.78,1.22.35,1,1,.93.59.43,1.81,1,1.87.88,2.93.53,2.65.65,3.58.22,0,1.15.22.78.12,1.16-.65,1-1.23.59-2.73-.83-3.26.14-3.26,1.2-.43.95-1.55a3.25,3.25,0,0,1,0-1.75c.06-.69-.78-.9-.22-1.65s.75-.47,1.56-.28,1.87,0,1.93-1.12.06-.72.44-1.65.62-1.38.87-2.09.41-.63.41-1.31.24-1-.25-1.28-.85-.78-.16-1.12a4,4,0,0,0,1.5-2.8,4.56,4.56,0,0,1,.18-1.47,2.49,2.49,0,0,0-.28-1.31c0-.09-.81-.87.06-1s.88-1,1.5-1.53,1-1,1.56-1.53.84-1.46,1.49-1.49,1.59-.38,1.84-.16.53.81,1.19.81.74-.4.68-1.06-1.49-1.62-.75-2.12S310,55.71,309.45,55s-.84-1.15-.74-1.43-1.31-.56-1.5-.56-.56,1-1,.34-1.59.13-1.84-.12.78-1.84.66-2.22-.31-1-.69-1-1.34.9-.93-.06,1.24-1.28.5-1.56-1-.19-1.28-.66-2.28,1-2.37,2.25-3.11,0-3.39-.69-.82-.09-1.34.47-.81.4-1.1,1.18-.12,1.06-.87,1.37-.47.72-2.27.75-.72,1.65-1.28,1.9-1.31.31-1.65.81-.9,1-.78,1.19.78.65-.09,1.12-1.28-.16-2,.15-1.28.41-1.71.13-.78-.53-.84,0-.6,1.87.9,2.06,2.09.12,1.81,1.18-.53,1.81-1.53,1.84a8,8,0,0,0-2.87.5,2.18,2.18,0,0,1-2.36-.19c-.36-.44-.5-.53-1.25-.06s-1.68.28-1.93.9-1.06,0-1.4-.5-1.1.07-1.59.25-2-1.15-1.47-1.65a.9.9,0,0,0,.16-1.26.52.52,0,0,0-.1-.11.87.87,0,0,1-.22-1.2l.07-.08c.4-.56.56-1.18,0-1.55s-.28-1.1-.94-.75-.77.93-1.55,1-1.47.1-1.28.78.56.78,0,1.75-.87,1.18-.59,1.93.31,1.49.9,2,0,2.31-.75,2-2.46.4-3.27-.1-.87-.71-1.71-.25-1.5.38-1.75-.12A1,1,0,0,0,259,66.3c-.53.16-.72.07-1.37-.21s-.16-.75-.85-.81-.53.49-1.46.28-2.93-.72-3-1.38-.25-1.4-.9-1.52-1.56-1-2.47-.53-1,.22-1.8.19-1.22.74-2.28.12-.71-1.34-1.27-1.25-1.06.72-2.06-.09-1.62,0-2.52-.34-.5-.5-1.19-.87-.25-.94-1.06-1.22a3.12,3.12,0,0,1-1.4-1c-.06-.09-1.46,0-1.78-.37s-.4-1.09-.74-1-.41.13-.41.34-1.49-.93-1.65-1.09.12-.37.28-.56a2.33,2.33,0,0,0,.47-1.06c.22-.75.12-1.31.28-1.56s.22-1.24.37-1.34a12.48,12.48,0,0,0,1.15-1.15c.07-.09.88-.75.88-.75s1.21-.59,1-1.06-.56-.37-1.09-.49-.43-.94-1.28-1-1.65,0-1.58-.65-.94-1.19-1.66-1.53-.59-.53-1.09-.47-.84.41-1.27-.81-1.09-1.71-1.59-1.43-.72,1.52-1.09.43.34-.93.34-1.59-.25-.15-.25-1.15-.06-.93-.5-1.49a2.35,2.35,0,0,1-.68-1.31c0-.47-.75-1.34.25-1.16s1.27.57,1.34.88.87.15,1.3-.19a2.83,2.83,0,0,1,1.25-.62c.53-.13.93-.1.9-.6s-1.27-1.52-1.09-2.21.5-1.43-.53-1.52-2.27.12-1.71-1,1.34-.78.72-1.59-1-.9-.38-1.19,1.37,1.34,2.12.25.09-2.74,1-2.64,1.46,0,1.31-.69,1.06-.41,1.06-1.37,1.21-1.47,1-2.34,0-1.87-.56-2.05a7.63,7.63,0,0,1-2.61-1.19c-1.34-.9-.91-.9-1.53-.62s-.72.62-1.75.59-.68-.25-1.68.09Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 84.39,
    cy: 55.75,
    r: 14.85,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": 6,
    fill: "#000000",
    className: "color000 svgShape"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 78.88,
    height: 71.55,
    x: 62.49,
    y: 35.43,
    fill: "#e7f5fe",
    className: "colore7f5fe svgShape"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 84.39,
    cy: 55.75,
    r: 14.85,
    fill: "#ffffff",
    className: "colorfff svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)",
    fill: "#000000",
    className: "color000 svgShape"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fbbda6",
    d: "M95.4,67.9l.66,23.43-.2-1,6.67,21.14a1.23,1.23,0,0,1-2.27.92l-9.78-19.9a2.14,2.14,0,0,1-.2-.75v-.22L89.09,68.15a3.16,3.16,0,0,1,6.31-.32Z",
    className: "colorfbbda6 svgShape"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#153f56",
    d: "M92.25,64.19s-3.38.6-3.83,3.35.36,22.45,1.07,25,9,19.33,9,19.33a46.26,46.26,0,0,1,4.45-1.61L96.07,91.47l.7-19.13S97.61,65,92.25,64.19Z",
    className: "color153f56 svgShape"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbbda6",
    d: "M80.75,67.13c.08-3.23.54-14.2.53-14.32l6.32-.17c0,.47,0,11.32-.06,14.71Z",
    className: "colorfbbda6 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M81.28,52.81l6.32-.17v8a3.11,3.11,0,0,1-3.25,1c-2.23-.57-2.56-1-3.27-1.78C81.18,56.94,81.29,52.87,81.28,52.81Z",
    style: {
      isolation: "isolate"
    },
    fill: "#fbbda6",
    opacity: 0.45,
    className: "colorfbbda6 svgShape"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#194866",
    d: "M94,64.61a78.81,78.81,0,0,1,1.49,9.78c1.29,16,2,33.72,2,33.72a73.89,73.89,0,0,0-11.42.59,46.74,46.74,0,0,1-14.5-.59s1.93-6,1.93-18.27c0-11.26-4.86-23.82.39-25.06A39,39,0,0,1,84,63.91C89,64,93.75,64.09,94,64.61Z",
    className: "color194866 svgShape"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbbda6",
    d: "M88 63.47s-.13 2.66-2.46 3.23c-1.65.4-6.15-.24-6.62-3.05l2.8-.21 4 .21zM78.78 55.49c-1.19-2.33-.72-5.78-.41-6.89a3.8 3.8 0 01.18-.47c.68-1.49 3.09-4.82 6.59-4a7.3 7.3 0 011.35.5c2.73 1.42 3 4.54 3.15 6.54v1.27c0 4.7-1.94 7.06-2 7.07-1 1.59-4.94 1-6.5-.49A13.71 13.71 0 0178.78 55.49z",
    className: "colorfbbda6 svgShape"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M78.57,63.91l9.34,22.34.71-22.34A80.24,80.24,0,0,1,78.57,63.91Z",
    className: "colorfff svgShape"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#65a8df",
    points: "87.91 86.25 82.05 77.52 84.95 66.02 85.36 65.78 88.25 75.45 87.91 86.25",
    className: "color65a8df svgShape"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#1d334a",
    points: "88.62 63.76 87.91 86.25 90.53 75.62 89.99 75.31 91.42 63.91 88.62 63.76",
    className: "color1d334a svgShape"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#1d334a",
    points: "87.91 86.25 78.57 63.63 76 64.03 81.83 75.91 81.46 76.2 87.91 86.25",
    className: "color1d334a svgShape"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#65a8df",
    points: "84.88 64 86.32 65.83 85.6 68.03 83.58 65.83 84.88 64",
    className: "color65a8df svgShape"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d334a",
    d: "M78.57,52.88s.48-4.13,2.37-3.93,2.08,0,3.5.26c1.91.33,5.56.44,5.49-.92s.22-2.36-1.31-2.83-.32-.75-2.26-1.4a6,6,0,0,0-3.43-.53c-1.3.12-3.44.84-4,2a8.72,8.72,0,0,0-1.44,4.15,9.48,9.48,0,0,0,.38,4.17c.38.83,2,4.33,2.28,3.65S78.57,52.88,78.57,52.88Z",
    className: "color1d334a svgShape"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbbda6",
    d: "M79.52,53.51c.07.75-.27,1.7-.79,1.75s-1-.83-1.11-1.57a1.17,1.17,0,0,1,.83-1.43C79,52.21,79.45,52.77,79.52,53.51Z",
    className: "colorfbbda6 svgShape"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d334a",
    d: "M88.29,49.14s1.06-.87,1.19,2.41a16.06,16.06,0,0,1-.69,5.51,11.25,11.25,0,0,0,1.31-3.55,47.17,47.17,0,0,0-.24-6.06Z",
    className: "color1d334a svgShape"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbbda6",
    d: "M88.63,53.51c-.07.75.27,1.7.79,1.75s1-.83,1.1-1.57a1.18,1.18,0,0,0-.82-1.43C89.18,52.21,88.7,52.77,88.63,53.51Z",
    className: "colorfbbda6 svgShape"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#d3e9f4",
    d: "M80.61,62l-2,1.64s1,2.2,5,2.2L84.88,64l1.44,1.83s3.05-.11,3.25-2.07L88,62S87.27,65.73,80.61,62Z",
    className: "colord3e9f4 svgShape"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d334a",
    d: "M79.08,50.74s0,4.14,1.61,4.71a19,19,0,0,0,5.41.6c1.4,0,3.56-.3,3.33-5.19-.19-4.08.36,1.22.36,1.22l-.53,4.12s-1,4.13-2.94,4.29c-1.7.14-4.38.06-5.57-1.39s-2.18-7.75-2.18-7.75Z",
    className: "color1d334a svgShape"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 34.4,
    height: 1.89,
    x: 102.88,
    y: 43.13,
    fill: "#194866",
    className: "color194866 svgShape"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 34.4,
    height: 1.49,
    x: 102.88,
    y: 47.81,
    fill: "#7a8e99",
    className: "color7a8e99 svgShape"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 34.4,
    height: 1.49,
    x: 102.88,
    y: 51.5,
    fill: "#7a8e99",
    className: "color7a8e99 svgShape"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 34.4,
    height: 1.49,
    x: 102.88,
    y: 55.19,
    fill: "#7a8e99",
    className: "color7a8e99 svgShape"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 69.71,
    height: 1.49,
    x: 66.71,
    y: 89.33,
    fill: "#7a8e99",
    className: "color7a8e99 svgShape"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 69.71,
    height: 1.49,
    x: 66.71,
    y: 93.44,
    fill: "#7a8e99",
    className: "color7a8e99 svgShape"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 69.71,
    height: 1.49,
    x: 66.71,
    y: 97.59,
    fill: "#7a8e99",
    className: "color7a8e99 svgShape"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffd846",
    points: "70.75 77.03 72.43 73.26 74.4 76.89 78.51 77.33 75.66 80.33 76.52 84.37 72.79 82.59 69.21 84.65 69.75 80.55 66.69 77.78 70.75 77.03",
    className: "colorffd846 svgShape"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffd846",
    points: "85.42 77.03 87.11 73.26 89.07 76.89 93.18 77.33 90.33 80.33 91.19 84.37 87.46 82.59 83.88 84.65 84.42 80.55 81.36 77.78 85.42 77.03",
    className: "colorffd846 svgShape"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffd846",
    points: "100.42 77.03 102.1 73.26 104.07 76.89 108.18 77.33 105.33 80.33 106.19 84.37 102.46 82.59 98.88 84.65 99.42 80.55 96.35 77.78 100.42 77.03",
    className: "colorffd846 svgShape"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffd846",
    points: "115.04 77.03 116.73 73.26 118.7 76.89 122.81 77.33 119.96 80.33 120.81 84.37 117.09 82.59 113.51 84.65 114.05 80.55 110.98 77.78 115.04 77.03",
    className: "colorffd846 svgShape"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffd846",
    points: "129.79 77.03 131.48 73.26 133.45 76.89 137.56 77.33 134.71 80.33 135.56 84.37 131.84 82.59 128.26 84.65 128.8 80.55 125.73 77.78 129.79 77.03",
    className: "colorffd846 svgShape"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbbda6",
    d: "M52.78,159.07s.91,1.3,2.29,3.23,2.21,4.95,1.29,5.11a1.17,1.17,0,0,1-1.27-.57s.81.64-.14.88a.77.77,0,0,1-1-.39.7.7,0,0,1-.06-.19s.22.84-.53,1a.62.62,0,0,1-.75-.47.5.5,0,0,1,0-.17s.4.51-.62.66-2-7.72-2-7.72Z",
    className: "colorfbbda6 svgShape"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f444c",
    d: "M38.53,174.14,66.87,167h0l6,23.7h0l-29.38,7.4h0l-5.7-22.63A1.1,1.1,0,0,1,38.53,174.14Z",
    className: "color1f444c svgShape"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#6b4200",
    d: "M60.84,175.08a.79.79,0,0,0,.54-1v0L59,164.5a.8.8,0,0,0-.94-.62L48.8,166.2a.8.8,0,0,0-.53,1h0l2.22,8.8a.76.76,0,0,0,1.5-.26l0-.11-2-8,7.75-1.95,2.21,8.78A.8.8,0,0,0,60.84,175.08Z",
    className: "color6b4200 svgShape"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#9b7600",
    d: "M42.58,173.11,69,166.46a1.55,1.55,0,0,1,1.87,1.12v0l5.59,22.21h0l-29.4,7.4h0L41.47,175a1.54,1.54,0,0,1,1.08-1.89Z",
    className: "color9b7600 svgShape"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 30.32,
    height: 10.06,
    x: 42.17,
    y: 170.92,
    transform: "rotate(-14.13 57.333 175.955)",
    style: {
      isolation: "isolate"
    },
    fill: "#9b7600",
    opacity: 0.28,
    className: "color9b7600 svgShape"
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#885700",
    d: "M42.42,173.17l26.72-6.73a1.38,1.38,0,0,1,1.67,1l2.12,8.41h0l-29.4,7.4h0l-2.12-8.41A1.37,1.37,0,0,1,42.42,173.17Z",
    className: "color885700 svgShape"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 3.95,
    height: 3.3,
    x: 65.03,
    y: 176.3,
    fill: "#ffd846",
    transform: "rotate(-14.13 67.001 177.932)",
    className: "colorffd846 svgShape"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 3.95,
    height: 0.76,
    x: 63.02,
    y: 166.64,
    fill: "#ffd846",
    transform: "rotate(-14.13 64.993 167.032)",
    className: "colorffd846 svgShape"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 3.95,
    height: 0.76,
    x: 42.09,
    y: 171.9,
    fill: "#ffd846",
    transform: "rotate(-14.13 44.068 172.263)",
    className: "colorffd846 svgShape"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 2.6,
    height: 2.17,
    x: 65.71,
    y: 176.86,
    fill: "#885700",
    transform: "rotate(-14.13 67.001 177.932)",
    className: "color885700 svgShape"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 3.95,
    height: 3.3,
    x: 48.39,
    y: 180.5,
    fill: "#ffd846",
    transform: "rotate(-14.13 50.381 182.14)",
    className: "colorffd846 svgShape"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 2.59,
    height: 2.17,
    x: 49.07,
    y: 181.06,
    fill: "#885700",
    transform: "rotate(-14.13 50.381 182.14)",
    className: "color885700 svgShape"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbbda6",
    d: "M45.64,109.59l.78,27.53L46.18,136,54,160.83a1.44,1.44,0,1,1-2.67,1.08L39.86,138.52a2.39,2.39,0,0,1-.23-.87v-.26l-1.39-27.51a3.71,3.71,0,0,1,7.41-.37Z",
    className: "colorfbbda6 svgShape"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#153f56",
    d: "M41.94,105.23s-4,.7-4.51,3.93.43,26.38,1.27,29.44,10.51,22.72,10.51,22.72a53.49,53.49,0,0,1,5.23-1.9l-8-22.14.84-22.48S48.23,106.17,41.94,105.23Z",
    className: "color153f56 svgShape"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbbda6",
    d: "M82.4,145.25a13.58,13.58,0,0,0-3.92,2.09c-6,4.69-6.24,2.15-8.12,1.32s1.63-3.29,4.2-3.73S78.31,143.48,82,142C84.32,141.09,82.4,145.25,82.4,145.25Z",
    className: "colorfbbda6 svgShape"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbbda6",
    d: "M112.55,117.53l-10.21,22-.13.28a2.71,2.71,0,0,1-1.85,1.51l-21.14,5a1.42,1.42,0,0,1-.89-2.68L98.26,135l-2,1.8,9.66-22.25a3.63,3.63,0,1,1,6.8,2.56l-.15.33Z",
    className: "colorfbbda6 svgShape"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#d6e2ea",
    d: "M77.27,143.5s.52,2.52,1.83,3.57c0,0,17-4.34,19.17-4.63s5.74-1.29,6.48-4.22-2.34-20.35-2.34-20.35l-5.87,17.47Z",
    className: "colord6e2ea svgShape"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d334a",
    d: "M104.11,98.73v14.51l16.72,17.55s5.35,4.86,15.51-1.84-15.65-21.8-15.65-21.8L114,101.09Z",
    className: "color1d334a svgShape"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbbda6",
    d: "M110.47,114.81c-.31-3.69-1.12-16.27-1.14-16.4l7.19-1c.07.53,1.75,13.06,2.08,16.94Z",
    className: "colorfbbda6 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M112.49,106.54l.85-.48A14.93,14.93,0,0,0,117,102c-.15-1.14-.25-1.9-.27-2l-7.18,1a52.94,52.94,0,0,0,.39,6.42,20.92,20.92,0,0,0,2.56-.77Z",
    style: {
      isolation: "isolate"
    },
    fill: "#fbbda6",
    opacity: 0.6,
    className: "colorfbbda6 svgShape"
  }), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbbda6",
    d: "M116.77 98.79c1-2.82 0-6.68-.46-7.91-.08-.17-.17-.34-.27-.52-1-1.6-4.18-5.07-8.05-3.64a8.48 8.48 0 00-1.47.75c-2.93 2-2.83 5.58-2.72 7.88 0 0 .09 1 .15 1.45a21.92 21.92 0 002.76 7.76c1.34 1.73 3.84.65 6.08-.56.24-.15.46-.3.68-.46A14.5 14.5 0 00116.77 98.79zM111.15 155.78l-.53 9.94-.6 9.92-.66 9.93-.68 9.93v-.35l-.07 24.14-.1 12.07-.18 12.07a2.09 2.09 0 01-4.16.18l-1.24-12-1.17-12-2.21-24v-.34l-.07-10V165.37l.09-9.94a5.82 5.82 0 0111.64.1A.48.48 0 00111.15 155.78z",
    className: "colorfbbda6 svgShape"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#e7f5fe",
    d: "M104.27,111.15s-5.6,9.41-5.56,12.35c0,1.81.07,2.58,1.87,7s1,11.39,1,11.39.55,9.33.4,20.81,21.5,14.9,22.71,3.57c1.44-13.37-5.12-19.84-4.43-24.07s7.54-30.29,2.81-31.5C115.88,108.88,104.77,110,104.27,111.15Z",
    className: "colore7f5fe svgShape"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbbda6",
    d: "M104.7,240.42l-.55,2.43A7.23,7.23,0,0,1,103,247.7c-1.52,1.93-8.15,3.39-10,4.43s.51,1.25,5.4,1.17,8.18-.27,9.73-.27.9-4.48.43-6.44a35.09,35.09,0,0,1-.43-4.8Z",
    className: "colorfbbda6 svgShape"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d334a",
    d: "M109,249.34a7.68,7.68,0,0,1-3.32,1.61c-2.18.34-5.52.55-6.82,0-.76-.32-.86-.63-.83-.84-2,.79-4,1.47-5,2-1.87,1,.51,1.25,5.4,1.17s8.18-.27,9.73-.27C109.09,253,109.41,251.14,109,249.34Z",
    className: "color1d334a svgShape"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbbda6",
    d: "M123.06,154.82l.2,10.13.11,10.14.07,10.14v10.14l-.18-1.07,5.49,23.27,2.68,11.65L134,240.9a2.08,2.08,0,0,1-4,1.14l-4-11.28-3.91-11.3-7.68-22.64a2.65,2.65,0,0,1-.15-.69v-.38l-.79-10.11-.77-10.11L112,165.41l-.64-10.11a5.82,5.82,0,0,1,11.62-.74A.5.5,0,0,1,123.06,154.82Z",
    className: "colorfbbda6 svgShape"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbbda6",
    d: "M130.14,238.61l-.22,2.48a7.17,7.17,0,0,1-.43,4.95c-1.24,2.13-7.6,4.48-9.31,5.77s.67,1.16,5.51.42,8.06-1.39,9.59-1.61.28-4.55-.45-6.43a36,36,0,0,1-1.09-4.7Z",
    className: "colorfbbda6 svgShape"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d334a",
    d: "M135.66,246.85a7.77,7.77,0,0,1-3.06,2.05c-2.12.63-5.4,1.3-6.76.93-.8-.21-.94-.51-.94-.72-1.84,1.06-3.81,2-4.72,2.7-1.71,1.28.67,1.16,5.51.42s8.06-1.39,9.59-1.61C136.22,250.49,136.28,248.58,135.66,246.85Z",
    className: "color1d334a svgShape"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbbda6",
    d: "M115.19,95.46s.6-1.19,1.69-.15-1,5.06-1,5.06Z",
    className: "colorfbbda6 svgShape"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#e66748",
    d: "M120.73,143.73s5.62,9,5.75,18.89,2.81,32.29,2.81,32.29-26.68,2.43-33.29,0c0,0,.94-41.22,5.59-51.94C101.59,143,107.29,146.15,120.73,143.73Z",
    className: "colore66748 svgShape"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#edac98",
    d: "M69.27,143.81a11.53,11.53,0,0,0,4.12.63l1,1.82a4.9,4.9,0,0,0,2.89,2c2,.48.16,1.11-.35.85,0,0,.29.9-.78.69,0,0,.2,1-.73.87,0,0,.34.81-.7.72,0,0-2.37-.23-7.09-4.61C64.53,143.82,69.27,143.81,69.27,143.81Z",
    className: "coloredac98 svgShape"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbbda6",
    d: "M76.76 144.41s-2.14-.91-3.22-.42-2.07 2-1.65 2.15 2.69-1.15 3.28-1S76.76 144.41 76.76 144.41zM70 149.41s-.18-.44.86-.8S70.88 150.81 70 149.41z",
    className: "colorfbbda6 svgShape"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbbda6",
    d: "M70.77,150s-.18-.44.85-.8S71.64,151.43,70.77,150Z",
    className: "colorfbbda6 svgShape"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbbda6",
    d: "M71.59,150.62s-.23-.41.75-.89S72.63,151.9,71.59,150.62Z",
    className: "colorfbbda6 svgShape"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbbda6",
    d: "M72.46,151.13s-.19-.34.64-.76S73.35,152.22,72.46,151.13Z",
    className: "colorfbbda6 svgShape"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 18.38,
    height: 24.6,
    x: 106.29,
    y: 130.12,
    fill: "#1d334a",
    transform: "rotate(-21.09 115.472 142.412)",
    className: "color1d334a svgShape"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d334a",
    d: "M35.13,152.05l-2.72,45.23v.42l-8.53,48.43a2.92,2.92,0,0,1-5.79-.7l5-48.86V197l.16-45.31a6,6,0,0,1,11.92,0A1.89,1.89,0,0,0,35.13,152.05Z",
    className: "color1d334a svgShape"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d334a",
    d: "M46.4 153.4l.68 45.28c0 .94 0 1.89-.09 2.83l-.16 2.83L46.52 210l-.63 11.32-.38 22.6a2.92 2.92 0 01-5.83-.09l-1.42-22.52c-.2-7.5-.32-15-.6-22.5L34.5 153.9a6 6 0 1111.88-.83C46.39 153.17 46.39 153.29 46.4 153.4zM22.89 245.15a4 4 0 002.78 3.91c2.95 1 8.38 1.69 8.94 4.06s-9.95 1.36-14.17.56-3.32-.56-3.33-4.39.73-5.28.73-5.28z",
    className: "color1d334a svgShape"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d334a",
    d: "M46.15 245.15a4 4 0 002.78 3.91c3 1 8.38 1.69 8.94 4.06s-9.95 1.36-14.17.56-3.32-.56-3.33-4.39-.14-5.28-.14-5.28zM35.59 157.83s-1 30-2 39.17-8.18 51.42-8.18 51.42a11.18 11.18 0 01-8.83-1.26s1.9-33.66 4.42-47.72l-2.69-43.35z",
    className: "color1d334a svgShape"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d334a",
    d: "M47.41,156.59s.69,29.95.74,39.14-.44,51.93-.44,51.93a11.18,11.18,0,0,1-8.91-.24s-3.7-33.55-2.86-47.81l-7.67-42.75Z",
    className: "color1d334a svgShape"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbbda6",
    d: "M26.55,108.68c.09-3.8.63-16.69.63-16.82l7.42-.21c0,.55,0,13.31-.07,17.29Z",
    className: "colorfbbda6 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.18,91.86l7.42-.21V102a14.55,14.55,0,0,1-3.21-.53l-.79-.28a12.66,12.66,0,0,1-3.67-3C27.06,94.83,27.18,91.92,27.18,91.86Z",
    style: {
      isolation: "isolate"
    },
    fill: "#fbbda6",
    opacity: 0.45,
    className: "colorfbbda6 svgShape"
  }), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#194866",
    d: "M44,105.72a92.92,92.92,0,0,1,1.75,11.49c1.52,18.84,2.4,39.63,2.4,39.63a88.56,88.56,0,0,0-13.42.69,55.11,55.11,0,0,1-17-.69S20,149.78,20,135.37c0-13.24-5.71-28,.46-29.45a45.34,45.34,0,0,1,11.9-1C38.16,104.94,43.7,105.11,44,105.72Z",
    className: "color194866 svgShape"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbbda6",
    d: "M37 104.38s-.15 3.13-2.89 3.79c-1.94.48-7.22-.28-7.77-3.58l3.28-.25 4.75.25zM26.34 94.89c-1.39-2.74-.84-6.79-.49-8.09.07-.19.14-.38.22-.56.8-1.75 3.64-5.66 7.74-4.67a8.89 8.89 0 011.59.58c3.21 1.67 3.54 5.34 3.71 7.69v1.49a22.45 22.45 0 01-1.88 8.22h0c-1.13 1.88-3.8 1.08-6.23.13l-.74-.39A15 15 0 0126.34 94.89z",
    className: "colorfbbda6 svgShape"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#194866",
    d: "M17.66,156.84s18.27,3.26,21,0c0,0,1.31,2.48,9.45,0l-10.44-5Z",
    className: "color194866 svgShape"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M25.86,104.89l11,26.26.83-26.26A89.81,89.81,0,0,1,25.86,104.89Z",
    className: "colorfff svgShape"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#65a8df",
    points: "36.84 131.15 32.76 120.88 33.37 107.37 33.85 107.09 37.24 118.46 36.84 131.15",
    className: "color65a8df svgShape"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#d3e9f4",
    d: "M26.76,102.64l-.9,1.93s1.13,2.58,5.9,2.58L33.28,105,35,107.15a3,3,0,0,0,2-2.77l-2.26-1.74S34.59,107,26.76,102.64Z",
    className: "colord3e9f4 svgShape"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#1d334a",
    points: "37.68 104.72 36.84 131.15 39.92 118.66 39.28 118.29 40.96 104.89 37.68 104.72",
    className: "color1d334a svgShape"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#1d334a",
    points: "36.84 131.15 25.86 104.57 22.84 105.04 29.7 119 29.26 119.33 36.84 131.15",
    className: "color1d334a svgShape"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#65a8df",
    points: "33.28 105 34.97 107.15 34.13 109.74 31.76 107.15 33.28 105",
    className: "color65a8df svgShape"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbbda6",
    d: "M126.79 113.26l7 25.45.09.32a3 3 0 01-2.08 3.7h0l-20.49 5.91a1.42 1.42 0 01-1-2.63l19.1-9.48-2 4-7.57-25.29a3.65 3.65 0 117-2.08A.31.31 0 00126.79 113.26zM122.62 196l1.26.3s2.72 3.35 5 12.08 5.78 35.15 5.78 35.15zM108.44 196s1.89 5.68 2 17.06-2.17 29.47-2 33-2.65-30.23-2.65-30.23l1.47-17.94zM108.64 110s-.42 4.13 3.14 4.71 5.81-5 5.81-5S111.52 109.2 108.64 110z",
    className: "colorfbbda6 svgShape"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#d6e2ea",
    d: "M112,144.81a10.87,10.87,0,0,0,1.23,3.45s19.14-3.43,21-6.76-7.49-28.58-7.49-28.58-1.54-3.65-5.07-3-3.68,6.2-2.42,10.7S126.13,137,126.13,137Z",
    className: "colord6e2ea svgShape"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbbda6",
    d: "M111.78,145.34a10.76,10.76,0,0,1-2.83.23c-1.15-.15-2.71-1-3-.15-.18.49,2.44.84,1.84,1.54s-1.75.25-1.54,1,.39.59.46,1.36,0,.87.35,1.08.21.84.38.89a1.08,1.08,0,0,0,.77.09c1.27-.46,3.16-.34,3.91-3.45S111.78,145.34,111.78,145.34Z",
    className: "colorfbbda6 svgShape"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d334a",
    d: "M104.75,89.38s-.12,3,4.79,4.23,4.84,3.55,6.31,6.76,0,8.15.34,10.88,2.13,6.93,8.73,8.65,6.29,11.14,11.42,9,1.57-18.67-6.39-21.8-9-10.91-11.11-15.31c-1.07-2.25-4.36-6.33-9.3-6.4S104.75,89.38,104.75,89.38Z",
    className: "color1d334a svgShape"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d334a",
    d: "M106.59,90.07s-2.86.69-2.79,5.28,2.34,7.37,2,10.12.82,4.53-.35,4.78-3.52,5.1-3.52,5.1a26.23,26.23,0,0,0,.69-9c-.62-4.08-1.12-17.94,3.32-18.4S106.59,90.07,106.59,90.07Z",
    className: "color1d334a svgShape"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#edac98",
    d: "M25.89,108.2,44,134.94l-1.74-1.3,28.85,11.43a1.44,1.44,0,1,1-.89,2.74h0l-30.07-7.7A2.86,2.86,0,0,1,38.56,139l-.13-.19L19.79,112.42a3.71,3.71,0,0,1,6-4.38l.07.1Z",
    className: "coloredac98 svgShape"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#153f56",
    d: "M39.35,140.68l-4.74-4.61c-2.8-2.72-22.74-24.72-14.76-29.75s20.76,24.93,24.85,27.34S69.1,143,69.1,143s-1.36,4.29-1.57,5.61C67.53,148.58,40,142.25,39.35,140.68Z",
    className: "color153f56 svgShape"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d334a",
    d: "M28,90.27s.59-3.23,2.81-3,3.69.91,5.39.91,3.62.21,3.54-1.39-.22-3-2-3.58-1.31-.89-3.58-1.65-2.52-.77-4-.63A4.61,4.61,0,0,0,26.3,83.3c-.65,1.36-1.57,2.39-1.69,4.87s0,3.93.44,4.9,1.58,3.54,1.87,2.74S28,90.27,28,90.27Z",
    className: "color1d334a svgShape"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbbda6",
    d: "M28.59,91.55c.08.88-.32,2-.93,2.06s-1.21-1-1.29-1.85.35-1.63,1-1.68S28.51,90.68,28.59,91.55Z",
    className: "colorfbbda6 svgShape"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d334a",
    d: "M29.08,87.92a4.17,4.17,0,0,0,.16,2.68c.55,1.76,1,4.11,3.2,4.09s6.24.31,6.24.31-.67,5.54-2.74,5.73-7.56-.65-7.72-3.88,1.09-5.53-.48-6.7.86-3.29.86-3.29Z",
    className: "color1d334a svgShape"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbbda6",
    d: "M51.45,167.59s-.33-1.45,0-1.53,1.38,1.48,1.2,1.7S51.45,167.59,51.45,167.59Z",
    className: "colorfbbda6 svgShape"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbbda6",
    d: "M53.14 165.77s-.26-.13-.34-.11a.52.52 0 00-.46.4c-.08.42.15 1.76.81 1.77s.57-.63.4-1.34S53.14 165.77 53.14 165.77zM53.88 167.14s-.42-1.57.13-1.65 1.06.83 1.13 1.18S53.88 167.14 53.88 167.14zM55.53 165s-.85.29-.36 1.32 1.28 0 1.28 0S56.18 164.73 55.53 165zM55.33 162.68a6.45 6.45 0 002.14 1c1 .19-1.52.71-2 .58S55.33 162.68 55.33 162.68z",
    className: "colorfbbda6 svgShape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessDeal);
export default __webpack_public_path__ + "static/media/business-deal.81590d01adfa132302f7931c0c2265ca.svg";
export { ForwardRef as ReactComponent };